const styles = () => ({
  hidden: {
    display: 'none',
  },
  todayIconMobile: {
    position: 'absolute',
    right: 20,
    top: 3,
  },
  gridActions: {
    whiteSpace: 'nowrap',
    marginRight: '20px',
  },
  todayIcon: { position: 'absolute', right: 40 },
});

export default styles;
